import React from 'react';
export const RejectedId = () => (
  <svg width="140px" height="114px" viewBox="0 0 140 114" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-802.000000, -1884.000000)">
        <g transform="translate(803.000000, 1884.000000)">
          <path
            d="M37.2686,109.5395 L18.5126,109.5395"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5128,109.5395 L0.4758,109.5395"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.9268,109.2758 C81.9268,111.3608 74.5628,113.0498 65.4778,113.0498 C56.3938,113.0498 49.0298,111.3608 49.0298,109.2758 C49.0298,107.1908 56.3938,105.5008 65.4778,105.5008 C74.5628,105.5008 81.9268,107.1908 81.9268,109.2758"
            fill="#D0D7DA"
          />
          <path
            d="M80.4014,66.9203 L29.5934,73.8013 C27.4574,74.0903 25.4914,72.5943 25.2024,70.4583 L21.1044,40.1993 C20.8154,38.0643 22.3124,36.0983 24.4474,35.8093 L75.2554,28.9283 C77.3914,28.6393 79.3574,30.1353 79.6474,32.2713 L83.7444,62.5293 C84.0344,64.6653 82.5374,66.6313 80.4014,66.9203"
            fill="#FFFFFF"
          />
          <g transform="translate(20.000000, 33.710000)">
            <path
              d="M17.4068,0.3529 L3.0198,2.3019 C1.6728,2.4839 0.7288,3.7239 0.9108,5.0719 L5.3958,38.1849 C5.5788,39.5329 6.8188,40.4759 8.1658,40.2939 L19.2958,38.7869 L24.6078,38.0669 L61.8288,33.0259 C63.1768,32.8429 64.1208,31.6039 63.9378,30.2559 L63.5878,27.6709"
              fill="#FFFFFF"
            />
            <path
              d="M17.4068,0.3529 L3.0198,2.3019 C1.6728,2.4839 0.7288,3.7239 0.9108,5.0719 L5.3958,38.1849 C5.5788,39.5329 6.8188,40.4759 8.1658,40.2939 L19.2958,38.7869 L24.6078,38.0669 L61.8288,33.0259 C63.1768,32.8429 64.1208,31.6039 63.9378,30.2559 L63.5878,27.6709"
              stroke="#C3D3D8"
              strokeWidth="1.001"
              strokeLinecap="round"
            />
          </g>
          <g transform="translate(21.000000, 33.710000)">
            <polyline
              fill="#F3F4F6"
              points="8.7115 13.598 1.2035 14.616 0.4065 8.73 58.9485 0.801 59.7465 6.687 11.8815 13.169"
            />
            <polyline
              stroke="#DDE3E2"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="8.7115 13.598 1.2035 14.616 0.4065 8.73 58.9485 0.801 59.7465 6.687 11.8815 13.169"
            />
          </g>
          <g transform="translate(40.000000, 47.710000)">
            <path d="M0.2833,3.9105 L23.0043,0.8335" fill="#DDE3E2" />
            <path
              d="M0.2833,3.9105 L23.0043,0.8335"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 51.710000)">
            <path d="M0.212,1.8168 L11.516,0.2858" fill="#DDE3E2" />
            <path
              d="M0.212,1.8168 L11.516,0.2858"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(40.000000, 50.710000)">
            <path d="M0.2339,3.7064 L23.3929,0.5694" fill="#DDE3E2" />
            <path
              d="M0.2339,3.7064 L23.3929,0.5694"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 54.710000)">
            <path d="M0.6011,1.5521 L11.5081,0.0751" fill="#DDE3E2" />
            <path
              d="M0.6011,1.5521 L11.5081,0.0751"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M91.939,61.1215 L43.269,61.1215 C40.396,61.1215 38.066,58.7925 38.066,55.9185 L38.066,27.9855 C38.066,25.1115 40.396,22.7825 43.269,22.7825 L91.939,22.7825 C94.813,22.7825 97.143,25.1115 97.143,27.9855 L97.143,55.9185 C97.143,58.7925 94.813,61.1215 91.939,61.1215"
            fill="#F3F4F6"
          />
          <path
            d="M95.7017,57.8256 L44.4297,57.8256 C42.2747,57.8256 40.5277,56.0786 40.5277,53.9236 L40.5277,23.3886 C40.5277,21.2336 42.2747,19.4866 44.4297,19.4866 L95.7017,19.4866 C97.8567,19.4866 99.6037,21.2336 99.6037,23.3886 L99.6037,53.9236 C99.6037,56.0786 97.8567,57.8256 95.7017,57.8256"
            fill="#FFFFFF"
          />
          <path
            d="M99.6041,42.2426 L99.6041,47.6966 L99.6041,55.3636 C99.6041,56.7226 98.5021,57.8256 97.1431,57.8256 L42.9891,57.8256 C41.6291,57.8256 40.5271,56.7226 40.5271,55.3636 L40.5271,21.9476 C40.5271,20.5886 41.6291,19.4866 42.9891,19.4866 L77.5361,19.4866 L82.7281,19.4866"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.3682,44.0404 L55.5732,44.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M59.6758,44.0404 L67.8808,44.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M71.9835,44.0404 L80.1885,44.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M84.2916,44.0404 L92.4966,44.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M47.3682,48.9633 L54.3432,48.9633"
            stroke="#C3D3D8"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M55.1788,39.5199 L48.1738,39.5199 C47.7288,39.5199 47.3678,39.1599 47.3678,38.7149 L47.3678,31.7089 C47.3678,31.2649 47.7288,30.9049 48.1738,30.9049 L55.1788,30.9049 C55.6238,30.9049 55.9838,31.2649 55.9838,31.7089 L55.9838,38.7149 C55.9838,39.1599 55.6238,39.5199 55.1788,39.5199"
            fill="#FEFCDD"
          />
          <path
            d="M55.1788,39.5199 L48.1738,39.5199 C47.7288,39.5199 47.3678,39.1599 47.3678,38.7149 L47.3678,31.7089 C47.3678,31.2649 47.7288,30.9049 48.1738,30.9049 L55.1788,30.9049 C55.6238,30.9049 55.9838,31.2649 55.9838,31.7089 L55.9838,38.7149 C55.9838,39.1599 55.6238,39.5199 55.1788,39.5199 Z"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <path
            d="M47.3682,35.2123 L55.9842,35.2123"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="50.7481 37.3754 49.6671 36.2954 49.6671 34.1304 50.7481 33.0504 52.6041 33.0504 53.6851 34.1304 53.6851 36.2954 52.6041 37.3754"
          />
          <path
            d="M52.7598,32.6733 L50.5928,32.6733 C50.0848,33.1823 49.7998,33.4663 49.2918,33.9753 L49.2918,36.4493 L50.5928,37.7503 L52.7598,37.7503 C53.2678,37.2423 53.5528,36.9573 54.0608,36.4493 L54.0608,33.9753 C53.5528,33.4663 53.2678,33.1823 52.7598,32.6733 M52.4488,33.4243 L52.5878,33.5633 L53.3098,34.2853 L53.3098,36.1393 L53.0858,36.3623 L52.4488,36.9993 L50.9038,36.9993 L50.1668,36.2633 L50.0428,36.1393 L50.0428,34.2853 L50.4528,33.8753 L50.9038,33.4243 L52.4488,33.4243"
            fill="#F5C400"
          />
          <path
            d="M137.6793,109.7367 L92.8893,109.7367"
            stroke="#EB1D26"
            strokeWidth="1.001"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M107.1714,27.0678 L94.2564,14.3508 C97.8034,11.8768 102.6554,12.2638 105.7924,15.5178 C108.9294,18.7708 109.5574,23.3878 107.1714,27.0678 M92.3404,29.0718 C89.0504,25.8288 88.6584,20.8128 91.1604,17.1448 L104.4384,30.2348 C100.7184,32.7018 95.6294,32.3148 92.3404,29.0718 M91.0464,11.4628 C90.5494,11.8378 90.0704,12.2498 89.6174,12.7018 C89.1644,13.1548 88.7534,13.6338 88.3774,14.1308 C84.3694,19.4378 84.7804,27.0198 89.6174,31.8568 C94.4534,36.6928 102.0364,37.1038 107.3424,33.0958 C107.8394,32.7208 108.3184,32.3098 108.7724,31.8568 C109.2254,31.4038 109.6364,30.9248 110.0114,30.4278 C114.0194,25.1208 113.6084,17.5388 108.7724,12.7028 C103.9354,7.8658 96.3534,7.4548 91.0464,11.4628"
            fill="#AA81F7"
          />
          <path
            d="M107.1714,27.0678 L94.2564,14.3508 C97.8034,11.8768 102.6554,12.2638 105.7924,15.5178 C108.9294,18.7708 109.5574,23.3878 107.1714,27.0678 Z M92.3404,29.0718 C89.0504,25.8288 88.6584,20.8128 91.1604,17.1448 L104.4384,30.2348 C100.7184,32.7018 95.6294,32.3148 92.3404,29.0718 Z M91.0464,11.4628 C90.5494,11.8378 90.0704,12.2498 89.6174,12.7018 C89.1644,13.1548 88.7534,13.6338 88.3774,14.1308 C84.3694,19.4378 84.7804,27.0198 89.6174,31.8568 C94.4534,36.6928 102.0364,37.1038 107.3424,33.0958 C107.8394,32.7208 108.3184,32.3098 108.7724,31.8568 C109.2254,31.4038 109.6364,30.9248 110.0114,30.4278 C114.0194,25.1208 113.6084,17.5388 108.7724,12.7028 C103.9354,7.8658 96.3534,7.4548 91.0464,11.4628 Z"
            stroke="#7350A0"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="88.9673 54.5795 96.6703 54.5795 96.6703 50.5715"
          />
          <path
            d="M83.5381,54.5795 L86.3941,54.5795"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M83.7266,10.9906 L79.5396,10.9336"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M89.3721,4.7904 L89.4291,0.6034"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M85.3023,6.2865 L82.3213,3.1445"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
